
import searchGetActions from './search';
import getDefinitionGetActions from './getDefinition';
import uiGetActions from './ui';

export * from './search';
export * from './getDefinition';
export * from './ui';

export function getActions(dispatch) {
    return {
        ...searchGetActions(dispatch),
        ...getDefinitionGetActions(dispatch),
        ...uiGetActions(dispatch)
    }
}
